import { render, staticRenderFns } from "./Specialize.vue?vue&type=template&id=b16e7e9c&scoped=true&"
import script from "./Specialize.vue?vue&type=script&lang=js&"
export * from "./Specialize.vue?vue&type=script&lang=js&"
import style0 from "./Specialize.vue?vue&type=style&index=0&id=b16e7e9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16e7e9c",
  null
  
)

export default component.exports